import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Tooltip from 'react-tooltip'
import Redirect from './Redirect'

import { callLogout } from '../actions'

import packageJson from '../../package.json'
import Logo from '../assets/solologo.svg'

import { uiConstants } from '../constants'
import { uiHelper } from '../helpers'

const initialState = {
  redirect: false,
  redirectTarget: null
}

class Nav extends Component {
  constructor() {
    super()
    this.state = initialState
  }

  canView(pos) {
    const { permission } = uiHelper.getActiveRole()
    if (!permission) return false
    return permission[pos] === '1'
  }

  componentDidUpdate() {
    const { permission } = uiHelper.getActiveRole()
    if (permission) {
      const p = window.location.pathname
      if (p !== '/settings') {
        uiConstants.menuList.forEach((el, index) => {
          if (p === el.label) {
            if (permission[index] === '0') {
              const index = permission.indexOf('1')
              this.setState({
                redirect: true,
                redirectTarget: uiConstants.menuList[index].label
              })
            }
          }
        })
      }
    }
  }

  render() {
    const { user } = this.props.auth
    const p = window.location.pathname

    return (
      <nav>
        <div className='ends'>
          <Link
            to='/settings'
            className='lnk-settings'
            title={'Anomaleet Suite - v. ' + packageJson.version}
          >
            <span className='img'>
              <img src={Logo} alt='anomaleet' />
            </span>
            <span className='icn'>
              <i className='fas fa-cogs'></i>
            </span>
          </Link>
        </div>
        <ul>
          {uiConstants.menuList.map((m, index) => {
            return (
              this.canView(index) && (
                <li key={index}>
                  <Tooltip
                    id={m.label}
                    effect='solid'
                    place='right'
                    className='nav-tip-upper'
                  >
                    {m.label}
                  </Tooltip>
                  <Link
                    to={m.link}
                    data-tip=''
                    data-for={m.label}
                    className={'lnk-nav ' + (p === m.label ? 'active' : '')}
                  >
                    <i className={m.icon}></i>
                  </Link>
                </li>
              )
            )
          })}
        </ul>
        {user !== null && (
          <div className='ends'>
            <button
              className='lnk-logout'
              onClick={() => this.props.callLogout()}
            >
              <span className='u'>{user.email[0]}</span>
              <span className='i'>
                <i className='fas fa-sign-out-alt'></i>
              </span>
            </button>
          </div>
        )}
        {this.state.redirect && <Redirect to={this.state.redirectTarget} />}
      </nav>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, { callLogout })(Nav)
